export enum LoadingMessage {
  PAYMENT_IN_PROGRESS = "payment_in_progress",
  AUTHENTICATION_IN_PROGRESS = "authentication_in_progress",
  PAYMENT_IS_PENDING = "payment.is_pending",
  PAYMENT_CONFIRMED_BOOKING_NOW = "payment.confirmed_booking_now",
}
